import { Inject, Injectable } from "@angular/core";
import { CustomerOtpVerificationInterface } from "./customer-otp-verification.interface";
import { BaseResponseModel } from "app/core/models";
import { Observable } from "rxjs";
import { OTPVerificationCustomerModel } from "../model/create-customer.model";
import { HTTP_SERVICE, HttpService } from "app/core/services";
import { API } from "../constant/api.const";

@Injectable()
export class CustomerOTPVerificationService implements CustomerOtpVerificationInterface{

    constructor(
        @Inject(HTTP_SERVICE) private _httpInterface:HttpService
    ){}

    verifyCustomerOTP(customerOTPVerificationData: OTPVerificationCustomerModel): Observable<BaseResponseModel<string>> {
        return this._httpInterface.post(API.VERIFY_CUSTOMER_OTP,customerOTPVerificationData);
    }

}